import React from 'react';
export default function Strong(props) {
  // ignore the eslint warning Text primitive does not support dataAttributes
  // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
  return /*#__PURE__*/React.createElement("strong", props.dataAttributes, props.children);
}